import React from 'react';
import { usePromotionsContext } from "../../hooks/usePromotionsContext";
import DiscountWidgetMobile from '../discountWidgetMobile';
import PromoCodeWidgetMobile from '../promoCodeWidgetMobile';

const PromoCodesContainerMobile = () => {
  const { appliedPromotionsData, availablePromoCodes } = usePromotionsContext();

  return availablePromoCodes.length ? (
    <PromoCodeWidgetMobile availablePromoCodes={availablePromoCodes}/>
  ) : appliedPromotionsData.appliedPromotions.length === 0 ? (
    <DiscountWidgetMobile />
  ) : null;
};

export default PromoCodesContainerMobile;
